const subscriptionFalseLength = document.getElementsByClassName('subscription-false');
if (subscriptionFalseLength.length > 0) {
  const subscriptionFalse = document.querySelector('.subscription-false');
}
const subscriptionTrueLength = document.getElementsByClassName('subscription-true');
if (subscriptionTrueLength.length > 0) {
  const subscriptionTrue = document.querySelector('.subscription-true');
}
const discountPercent = document.querySelector('#discount-percent');
const ogSsprice_length = document.getElementsByClassName('.price__regular .og-ss-price');
if (ogSsprice_length.length > 0) {
  const ogSsprice = document.querySelector('.price__regular .og-ss-price').textContent;
}
const ssFrequency = document.querySelector('#s_s');

setTimeout(function(){
  const ogOffer = document.querySelector('#shopify-block-ordergroove_offer span');
  if(ogOffer) {
    const ogOffersellingplan = ogOffer.getAttribute("selling-plan-id");
    if(ogOffersellingplan) {
      document.querySelector('.price__regular .price-item--regular').classList.add('strike');
      document.querySelector('.price__regular .og-ss-price').classList.remove('hidden');
      subscriptionTrue.classList.add('active');
      ssFrequency.classList.add('active');
    }
  }
}, 1000);

if (subscriptionFalseLength.length > 0) {
  if (subscriptionFalse.classList.contains('active')) {
    subscriptionTrue.classList.remove('active');
  }
  else {
    subscriptionTrue.classList.add('active');
    subscriptionFalse.classList.remove('active');
  }
}

if (subscriptionTrueLength.length > 0) {
  subscriptionTrue.addEventListener('click', function(event) {
      subscriptionPriceShowHide('sns')
  });
}

if (subscriptionFalseLength.length > 0) {
  subscriptionFalse.addEventListener('click', function(event) {
      subscriptionPriceShowHide('one-time')
  });
}
function subscriptionPriceShowHide(type){
  if(type === 'sns') {
    document.querySelector('.price__regular .og-ss-price').classList.remove('hidden');
    ssFrequency.classList.add('active');
    document.querySelector('.product-variant').classList.add('sns');
    document.querySelector('.product-variant').classList.remove('one-time');
    document.querySelector('.price__regular .price-item--regular').classList.add('strike');
    subscriptionTrue.classList.add('active');
    subscriptionFalse.classList.remove('active');
  }
  else {
    document.querySelector('.price__regular .og-ss-price').classList.add('hidden');
    ssFrequency.classList.remove('active');
    document.querySelector('.product-variant').classList.add('one-time');
    document.querySelector('.product-variant').classList.remove('sns');
    document.querySelector('.price__regular .price-item--regular').classList.remove('strike');
    subscriptionFalse.classList.add('active');
    subscriptionTrue.classList.remove('active');
  }
}
